import getApiBaseUrl from '@/utils/getBaseUrl';
import { useQuery } from '@tanstack/react-query';
import useGetProfile from './useGetProfile';

export interface MortgageCompany {
  _id: string;
  name: string;
  emailAddress: string;
  phoneNumber?: string;
  imageUrl?: string;
  createdAt: string;
  updatedAt: string;
  website?: string;
  mlsLicense?: string;
}

export default function useGetMortgageCompanies() {
  const { data: user } = useGetProfile();
  const token = window.localStorage.getItem('_token');

  return useQuery<MortgageCompany[]>({
    queryKey: ['ADMIN_MORTGAGE_COMPANIES'],
    queryFn: async () => {
      const response = await fetch(`${getApiBaseUrl()}/api/v1/mortgages`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: user?.role === 'ADMIN',
  });
}
